import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import { plainToClass } from "class-transformer";
import { SecurityUserModel } from "../../store/models/users/securityUsers";
import { ChangePasswordModel } from "../models/users/changePassword";
import { getTenantId } from "@/store/helper";
let UsersModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    let UsersModule = class UsersModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.user = null;
            this.users = [];
            this.responseUsers = [];
            this.apiNode = "tenantuser";
            this.dateFormats = null;
        }
        async InviteUser(tenantUser) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, tenantUser);
            if (data) {
                this.SetUser(plainToClass(SecurityUserModel, data.securityUser));
                return data;
            }
        }
        async UpdateUser(tenantUser) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.put(url, tenantUser);
            if (data) {
                this.SetUser(plainToClass(SecurityUserModel, data.securityUser));
                return data;
            }
        }
        async UpdatePassword(password) {
            var url = `${getTenantId()}/${this.apiNode}/password`;
            let { data } = await service.post(url, password);
            if (data) {
                var dd = data;
                return data;
            }
        }
        async GetAllUsers() {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.get(url);
            if (data) {
                this.AddUsers(plainToClass(SecurityUserModel, data.securityUsers));
                return data;
            }
        }
        async GetUserDetailById(userId) {
            var url = `${getTenantId()}/${this.apiNode}/` + userId;
            let { data } = await service.get(url);
            if (data) {
                this.SetSelectedUser(plainToClass(SecurityUserModel, data.securityUsers[0]));
                return data;
            }
        }
        async UploadProfilePicture(file) {
            var url = `${getTenantId()}/${this.apiNode}/profile-image`;
            //var image1: any = file;
            let { data } = await service.post(url, file);
            if (data) {
                return data;
            }
        }
        // Mutations
        AddUsers(users) {
            this.users = users;
        }
        SetSelectedUser(user) {
            this.user = user;
        }
        SetUser(user) {
            this.users.push(user);
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof SecurityUserModel !== "undefined" && SecurityUserModel) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], UsersModule.prototype, "InviteUser", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof SecurityUserModel !== "undefined" && SecurityUserModel) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], UsersModule.prototype, "UpdateUser", null);
    __decorate([
        Action({ rawError: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof ChangePasswordModel !== "undefined" && ChangePasswordModel) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], UsersModule.prototype, "UpdatePassword", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], UsersModule.prototype, "GetAllUsers", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof Guid !== "undefined" && Guid) === "function" ? _h : Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], UsersModule.prototype, "GetUserDetailById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof FormData !== "undefined" && FormData) === "function" ? _k : Object]),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], UsersModule.prototype, "UploadProfilePicture", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], UsersModule.prototype, "AddUsers", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof SecurityUserModel !== "undefined" && SecurityUserModel) === "function" ? _m : Object]),
        __metadata("design:returntype", void 0)
    ], UsersModule.prototype, "SetSelectedUser", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof SecurityUserModel !== "undefined" && SecurityUserModel) === "function" ? _o : Object]),
        __metadata("design:returntype", void 0)
    ], UsersModule.prototype, "SetUser", null);
    UsersModule = __decorate([
        Module({ dynamic: true, store: store, name: "users", namespaced: true })
    ], UsersModule);
    return UsersModule;
})();
export default getModule(UsersModule);
